export default "__VITE_ASSET__fce21503__"